import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/Button';
import useModal from '../../../hooks/useModal';
import SuccessDialog from './successDialog';

const SuccessDialogDemo = () => {
  const [showSuccessDialog, handleShowSuccessDialog, handleCloseSuccessDialog] =
    useModal();
  const navigate = useNavigate();

  const buttonForSuccessModal = (
    <Button
      variant="primary-outline"
      rightIcon={light('list-timeline')}
      onClick={() =>
        navigate('/health-savings-and-spending-channel/transaction-history')
      }
    >
      Transaction History
    </Button>
  );

  return (
    <Container>
      <Container className="mt-10">
        <h4>useMobile hook Demo</h4>
        <h6>open and resize the modal to test the feature</h6>
        <Button onMouseDown={handleShowSuccessDialog}>Open Modal</Button>
        <SuccessDialog
          showSuccessDialog={showSuccessDialog}
          handleCloseSuccessDialog={handleCloseSuccessDialog}
          button={buttonForSuccessModal}
        >
          <Container className="p-0 text-center">
            <p
              className="p-0 m-0 fw-light success-modal-text"
              style={{ lineHeight: '21px' }}
            >
              HSA Contribution Change submitted.
              <br /> A copy of the confirmation can be found under Transaction
              History.
              <br /> Changes will be applied to the next possible payment
              processing cycle.
            </p>
          </Container>
        </SuccessDialog>
      </Container>
    </Container>
  );
};

export default SuccessDialogDemo;
